<template>
  <!-- Teleport: header stacking context에 갇히면 Bootstrap backdrop이 모달을 가리므로 body로 이동 -->
  <Teleport to="body">
  <div class="modal fade" id="myPage" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5" id="staticBackdropLabel">{{ $t('myPage.modify') }}</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" ref="myButton"></button>
        </div>
        <div class="modal-body">
          <form id="detailForm">
            <table class="table_view table--block">
              <tbody>
              <tr>
                <!-- 아이디 -->
                <th><strong class="orange_font">*</strong> {{ $t('myPage.id') }}</th>
                <td data-label="아이디">
                  <input type="text" class="wi100" readonly v-model="form.loginId"/>
                </td>
                <!-- 이메일 -->
                <th>{{ $t('myPage.email') }}</th>
                <td data-label="이메일">
                  <input type="text" class="wi100" v-model="form.email"/>
                </td>
              </tr>
              <tr>
                <!-- 성명 -->
                <th><strong class="orange_font">*</strong> {{ $t('myPage.name') }}</th>
                <td data-label="성명">
                  <input type="text" class="wi100" v-model="form.name"/>
                </td>
                <!-- 그리드 Row 갯수 -->
                <th><small style="color: red;font-weight: bold;">&#42;&nbsp;</small>{{ $t('register.gridRow') }}<br>{{ $t('register.count') }}</th>
                <td>
                  <div class="form-inline input-group-sm">
                    <select v-model="form.gridRowCount" class="form-control">
                      <option v-for="gridRow in gridRowList" :value="gridRow.ref1" :key="gridRow.ref1">
                        {{ gridRow.ref1 }}
                      </option>
                    </select>
                  </div>
                </td>
              </tr>
              <tr>
                <!-- 전화번호1 -->
                <th><strong class="orange_font">*</strong> {{ $t('myPage.tel1') }}</th>
                <td data-label="전화번호1">
                  <input type="text" class="wi100" v-model="form.phoneNumberFirst" @keyup="phoneFormatter(this.form.phoneNumberFirst, 'phoneNumberFirst')"/>
                </td>
                <!-- 전화번호2 -->
                <th>{{ $t('myPage.tel2') }}</th>
                <td data-label="전화번호2">
                  <input type="text" class="wi100" v-model="form.phoneNumberSecond" @keyup="phoneFormatter(this.form.phoneNumberSecond, 'phoneNumberSecond')"/>
                </td>
              </tr>
              <tr>
                <!-- 언어 -->
                <th><strong class="orange_font">*</strong> {{ $t('myPage.language') }}</th>
                <td colspan="1">
                  <select v-model="form.language" class="wi100">
                    <option value="ko">한국어</option>
                    <option value="en">English</option>
                    <option value="jp">にほん</option>
                  </select>
                </td>
              </tr>
              <tr>
                <!-- 현재 비밀번호 -->
                <th>{{ $t('myPage.nowPassword') }}</th>
                <td>
                  <input type="password" class="wi100" v-model="nowPassword" autocomplete="new-password"/>
                </td>
              </tr>
              <tr>
                <!-- 비밀번호 변경 -->
                <th>{{ $t('myPage.passwordModify') }}</th>
                <td data-label="비밀번호 변경">
                  <input type="password" class="wi100" v-model="form.password" autocomplete="new-password"/>
                </td>
                <!-- 비밀번호 확인 -->
                <th style="border-top: 1px solid #dcdcdc;">{{ $t('myPage.password') }}<br> {{ $t('myPage.modifyConfirm') }}</th>
                <td style="border-top: 1px solid #dcdcdc;">
                  <input type="password" class="wi100" v-model="form.password2" autocomplete="new-password"/>
                </td>
              </tr>
              </tbody>
            </table>
          </form>
          <!-- *표시가 있는 것은 필수 값 -->
          <p class="text-left">{{ $t('textMessage.starRequired') }}</p>
          <!-- ※ 비밀번호 변경 시 현재 비밀번호 필수 입력  -->
          <p class="text-left mt5">{{ $t('textMessage.passwordRequired') }}</p>
          <!-- ※ 현재 비밀번호 입력 시 비밀번호 변경 및 비밀번호 변경 확인 항목은 필수 값입니다.  -->
          <p class="text-left mt5">{{ $t('textMessage.passwordModifiedRequired') }}</p>
          <!-- ※ 비밀번호 변경과 비밀번호 변경 확인은 일치 해야 합니다.  -->
          <p class="text-left mt5">{{ $t('textMessage.passwordSame') }}</p>
        </div>
        <div class="modal-footer">
          <button @click="register" type="button" class="btn btn-primary">{{ $t('button.save') }}</button>
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">{{ $t('button.close') }}</button>
        </div>
      </div>
    </div>
  </div>
  </Teleport>
</template>
<script>
import store from '@/store'
import { mapActions } from 'vuex'
import { getUserDetail, updateMyInfo } from '@/api/domain/user'
import { getCommonCodeSub } from '@/api/domain/common'

/**
 * @component MyPage
 * @description 개인정보 수정 모달 컴포넌트.
 * Bootstrap 모달(#myPage)을 사용하며, 이름/이메일/전화번호/언어/그리드 행 수/비밀번호 변경을 지원합니다.
 * 저장 시 유효성 검사 후 updateMyInfo API를 호출합니다.
 */
export default {
  // ── 반응형 데이터 ──
  data() {
    return {
      /** 수정 폼 데이터 */
      form: {
        loginId: '',
        name: '',
        email: '',
        teamId: '',
        phoneNumberFirst: '',
        phoneNumberSecond: '',
        password: '',
        password2: '',
        passwordChk: '',
        language: 'ko',
        gridRowCount: 10
      },
      /** 비밀번호 변경을 위한 현재 비밀번호 입력값 */
      nowPassword: '',
      /** 그리드 행 수 선택 목록 */
      gridRowList: []
    }
  },
  mounted() {
    const authToken = sessionStorage.getItem('authToken')

    if (authToken !== null) {
      this.form.loginId = store.state.auth.user.id.loginId
      this.setData()
    }
  },
  // ── 메서드 ──
  methods: {
    /**
     * 폼 유효성을 검사하고 개인정보 수정 API를 호출합니다.
     * 비밀번호 변경 시 현재 비밀번호 필수 및 일치 여부를 검증합니다.
     */
    async register() {
      if (this.form.name === '') { window.appAlert(this.$t('message.nameRequired')); return false }
      if (this.form.gridRowCount === '') { window.appAlert(this.$t('message.gridRowCountRequired')); return false }
      if (this.form.phoneNumberFirst === '') { window.appAlert(this.$t('message.phoneNumberFirstRequired')); return false }
      if (this.form.phoneNumberFirst.length > 15) { window.appAlert(this.$t('message.phoneNumberFirstRequired')); return false }
      if (this.form.phoneNumberSecond.length > 15) { window.appAlert(this.$t('message.phoneNumberFirstRequired')); return false }
      if (this.form.language === '') { window.appAlert(this.$t('message.languageRequired')); return false }
      // 새 비밀번호·확인 칸 중 하나라도 값이 있으면 비밀번호 변경 — 현재 비밀번호를 서버가 대조한다 (SURINP-709)
      const hasValue = v => v !== undefined && v !== null && v !== ''
      const isPasswordChange = hasValue(this.form.password) || hasValue(this.form.password2)
      if (isPasswordChange || hasValue(this.nowPassword)) {
        if (!hasValue(this.form.password)) { window.appAlert(this.$t('message.passwordRequired')); return false }
        if (!hasValue(this.form.password2)) { window.appAlert(this.$t('message.password2Required')); return false }
        if (!hasValue(this.nowPassword)) { window.appAlert(this.$t('textMessage.passwordRequired')); return false }
        if (this.form.password !== this.form.password2) {
          window.appAlert(this.$t('message.samePasswordRequired')); return false
        }
      }

      if (window.appConfirm(this.$t('message.saved'))) {
        this.form.phoneNumberFirst = this.$phoneFormatterHyphen(this.form.phoneNumberFirst)
        this.form.phoneNumberSecond = this.$phoneFormatterHyphen(this.form.phoneNumberSecond)

        // 비밀번호를 바꾸지 않으면 비밀번호 필드를 싣지 않는다 — 빈 문자열도 서버는 변경 요청으로 본다
        const body = { ...this.form }
        delete body.password
        delete body.password2
        delete body.passwordChk
        if (isPasswordChange) {
          Object.assign(body, { password: this.form.password, passwordChk: this.form.password2, currentPassword: this.nowPassword })
        }

        let result = ''
        result = await updateMyInfo(this.form.loginId, 'patch', body)
        if (result.status === 200) {
          window.location.reload()
        }
      }
    },
    /**
     * 사용자 상세 정보와 그리드 행 수 목록을 API에서 조회하여 폼을 초기화합니다.
     */
    async setData() {
      // user 상세 조회 api
      getUserDetail(this.form.loginId)
        .then(response => {
          store.commit('setUserRoleCode', response.userRoleCode)
          this.form = response
          this.form.phoneNumberFirst = this.$phoneFormatter(response.phoneNumberFirst)
          this.form.phoneNumberSecond = this.$phoneFormatter(response.phoneNumberSecond)
          this.setAdminTeamType(response.adminTeamType)
          this.setUserName(response.name)
        })
        .catch(error => { window.__APP_LOG__(error) })

      let gridList

      // 공통 코드 서브 조회
      getCommonCodeSub('ko-gridRow')
        .then(response => {
          // grid 숫자 낮은 순으로  재 정렬
          gridList = response
          gridList.sort((a, b) => parseInt(a.ref1) - parseInt(b.ref1))

          this.gridRowList = gridList
        })
        .catch(error => { window.__APP_LOG__(error) })
    },
    /**
     * 전화번호 입력 시 포맷을 적용하여 form 필드를 업데이트합니다.
     * @param {string} value - 원본 전화번호 문자열
     * @param {string} name - 업데이트할 form 필드명 ('phoneNumberFirst' 또는 'phoneNumberSecond')
     */
    phoneFormatter(value, name) {
      const formattedNum = this.$phoneFormatter(value)
      if (name === 'phoneNumberFirst') {
        this.form.phoneNumberFirst = formattedNum
      } else if (name === 'phoneNumberSecond') {
        this.form.phoneNumberSecond = formattedNum
      }
    },
    ...mapActions(['setAdminTeamType']),
    ...mapActions(['setUserName'])
  }
}
</script>
